import { ReactNode } from 'react';

// eslint-disable-next-line import/no-unresolved
import { Auth } from 'auth/services/Auth';
import { useLocation, Navigate } from 'react-router-dom';

import { getIdUiUrl } from '@utils/URLs';

const auth = Auth.getInstance();

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
    const isAuthenticated = auth.isAuthenticated();
    const location = useLocation();

    if (!isAuthenticated && process.env.IS_TESTING !== 'true') {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        if (process.env.NODE_ENV === 'development') {
            return <Navigate to="/login" state={{ from: location }} replace />;
        }

        // redirect to ID UI to auth there
        const url = getIdUiUrl();
        const paramReturn = `returnTo=${encodeURI(
            `${window.location.origin}${window.location.pathname}${window.location.search}`,
        )}`;
        window.location.replace(`${url}?${paramReturn}`);
        return null;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
